@if (series) {
  <div class="maintenance-series-detail">
    <div class="series-summary">
      <h4>{{series.TaskTypeName}}</h4>
      <div>Status: {{series.Status}}</div>
      <div>Rule: {{getRule()}}</div>
      <div>Timezone: {{series.TimeZoneId}}</div>
      @if (series.ApplyToAllTenants) {
        <div>All tenants</div>
      }
      @if (!series.ApplyToAllTenants) {
        <div>Selected tenants: {{getSelectedTenantNames(allTenants$ | async)}}</div>
      }
    </div>
    @if (series.NextOccurrences?.length) {
      <div class="next-occurrences">
        <h5>Next occurrences</h5>
        <ul>
          @for (occurrence of series.NextOccurrences; track occurrence) {
            <li>
              {{occurrence.LocalStartDateTime | date: 'dd/MM/yyyy HH:mm'}} {{occurrence.TimeZoneId}}
            </li>
          }
        </ul>
      </div>
    }
    <div class="series-actions">
      @if (series.Status === 'Active') {
        <button mat-raised-button class="mat-primary" (click)="pause()">Pause</button>
      }
      @if (series.Status === 'Paused') {
        <button mat-raised-button class="mat-primary" (click)="resume()">Resume</button>
      }
      @if (series.Status === 'Active') {
        <button mat-raised-button class="mat-warn" (click)="cancel()">Cancel Series</button>
      }
    </div>
  </div>
}
